import { render, staticRenderFns } from "./BrbDateTimeDisplay.vue?vue&type=template&id=2bd3c9d9&"
import script from "./BrbDateTimeDisplay.vue?vue&type=script&lang=js&"
export * from "./BrbDateTimeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/panel/driver/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bd3c9d9')) {
      api.createRecord('2bd3c9d9', component.options)
    } else {
      api.reload('2bd3c9d9', component.options)
    }
    module.hot.accept("./BrbDateTimeDisplay.vue?vue&type=template&id=2bd3c9d9&", function () {
      api.rerender('2bd3c9d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/brb-components/BrbDateTimeDisplay.vue"
export default component.exports